import { render, staticRenderFns } from "./loginWx.vue?vue&type=template&id=10683784&scoped=true"
import script from "./loginWx.vue?vue&type=script&lang=js"
export * from "./loginWx.vue?vue&type=script&lang=js"
import style0 from "./loginWx.vue?vue&type=style&index=0&id=10683784&prod&lang=less&scoped=true"
import style1 from "./loginWx.vue?vue&type=style&index=1&id=10683784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10683784",
  null
  
)

export default component.exports